export class SearchPaymentProcessorModel {
    // public name: string = '';
    // public dateFrom: any;
    // public dateTo: any;
    // public city : string='';
    // public isAsc : boolean=true;
    public pageSize: number = 10;
    public pageNumber: number = 1;
}